import styled from "styled-components";
export const TargetingStyle = styled.div`
  background-color: ${({ theme }) => theme.box};
  padding: 10px;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadow};
`;
